export function fixNameEnum(str?: string) {
  return !str
    ? undefined
    : `${str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()}`
        .replace(/_/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}
